import api from './api';
import { toast } from 'react-toastify';
import {
  COLUMNS_LIBERACAO_PROPOSTA
} from '../constants/mocks';

const setEditAnalisePagamentoTab = async (idContrato, tipo) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.get(`/bloqueioContrato?idContrato=${idContrato}&tipo=${tipo}`);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const salvarAnalise = async ({criterios,idContrato,infoAdicionais}) => {
  try {
    const client = await api('mesaveic');
    const analiseData = await client.post(`/analise/documentos`,{criterios,idContrato});
    if(infoAdicionais.length>0){
      const infoData = await client.post(`/analise/salvarInformacoesAdicionais`,{ idContrato, infoAdicionais });

      toast.success(infoData.data)
    }
    return analiseData;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const getInformacoesAdicionais = async (idContrato, keyTab) => {
  try {
    if (idContrato) {
      const client = await api('mesaveic');
      const { data } = await client.get(`/analise/informacoesAdicionais?idContrato=${idContrato}${keyTab ? `&keyTab=${keyTab}` : ''}`);
      return data ? data : '';
    }
    return '';
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return '';
  }
}

const salvarReanalise = async (dados) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.post(`/proposta/salvarReanaliseExclusao`, dados);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const getTabsData = async (idContrato, reanalise) => {

  let reanaliseParams = reanalise ? `reanalise=${reanalise}` : "";

  try {
    const client = await api('consulta');
    const { data } = await client.get(`/contrato/tabsAnalisePagamento?${reanaliseParams}`);

    if(data && data.error) {
      toast.error(data.error);
      return []
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

const getColumnsLiberacao = () => {
  try {
    return COLUMNS_LIBERACAO_PROPOSTA;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as colunas da liberação de proposta.');
    return null;
  }
};

const getDocsPendentesLiberacao = async (idContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`/analise/documentosPendentes?idContrato=${idContrato}`);

    if(data && data.error) {
      toast.error(data.error);
      return []
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

const liberarProposta = async (dados) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.post(`/analise/liberar`, dados);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const abonarProposta = async (dados) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.post(`/analise/abonar`, dados);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const logAnaliseTempoEsgotado = async (dados) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.post(`/analise/logAnalisarEsgotado`, dados);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const logAnaliseTempoAumentado = async (dados) => {
  try {

    const client = await api('mesaveic');
    const { data } = await client.post(`/analise/logAnalisarTempoExtendido`, dados);

    return data;
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const excluirSolicitacaoPag = async (dados) => {
  try {
    const client = await api('mesaveic');
    const { data, status } = await client.post('/exclusaoPagamento', dados);

    const success = status > 199 && status < 300;

    if (success) {
      return { success };
    } else {
      toast.error(data.errors);
      return { success, ...data };
    }

  } catch (error) {
    toast.error('Ocorreu um erro na requisição.');
  }
}

const regularizar = async (values) => {
  try {

    const client = await api('mesaveic');
    const { status } = await client.post(`/analise/regularizar`, values);
    return { success: status > 199 && status < 300 };
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return null;
  }
};

const getObservacoesContrato = async (idContrato) => {
  try {
    if (idContrato) {
      const client = await api('consulta');
      const { data } = await client.get(`/contrato/observacao?idContrato=${idContrato}`);
      return data ? data : '';
    }
    return '';
  } catch (error) {
    toast.error("Ocorreu um erro na requisição.");
    return '';
  }
}

export {
  setEditAnalisePagamentoTab,
  salvarAnalise,
  salvarReanalise,
  getTabsData,
  getColumnsLiberacao,
  getDocsPendentesLiberacao,
  liberarProposta,
  logAnaliseTempoEsgotado,
  logAnaliseTempoAumentado,
  abonarProposta,
  excluirSolicitacaoPag,
  regularizar,
  getInformacoesAdicionais,
  getObservacoesContrato
};
